var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('router-link',{staticClass:"router-link-wrapper-container",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('span',{staticClass:"router-link-wrapper-container disabled"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }